import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import About from './components/About/About';
import Experience from './components/Experience/Experience';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';
import content from './content';

const { about, experience, projects, contact } = content;

/**
 * A section appears on the page, and in the nav, only when content.js gives it
 * something to show. Order here is the order on the page.
 */
const sections = [
  { config: about, Component: About, hasContent: (c) => c.paragraphs.length > 0 || c.lists.length > 0 },
  { config: experience, Component: Experience, hasContent: (c) => c.entries.length > 0 },
  { config: projects, Component: Projects, hasContent: (c) => c.items.length > 0 },
  { config: contact, Component: Contact, hasContent: (c) => c.fields.length > 0 },
];

function App() {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    document.title = content.meta.title;
    const description = document.querySelector('meta[name="description"]');
    if (description) description.setAttribute('content', content.meta.description);
  }, []);

  const toggleTheme = () => {
    setTheme((previousTheme) => (previousTheme === 'dark' ? 'light' : 'dark'));
  };

  const visible = sections.filter(({ config, hasContent }) => hasContent(config));
  const navItems = visible.map(({ config }) => ({ id: config.id, label: config.navLabel }));

  return (
    <Router>
      <Header navItems={navItems} theme={theme} onThemeToggle={toggleTheme} />
      <Home />
      {visible.map(({ config, Component }) => (
        <Component key={config.id} />
      ))}
      <Footer />
    </Router>
  );
}

export default App;
